import React from "react";
import { connect } from "react-redux";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import Layout from "components/Layout";
import Modal from "components/Modal";
import ApprovedExpenses from "pages/ExpensesApproved";
import MobileExpensesView from "components/Expenses/Mobile/MobileExpensesView";
import { hideModal } from "actions/modalActions";

/**
 * Tablet/desktop: tabla de aprobados. Móvil: misma shell unificada que /expenses.
 */
const ApprovedExpensesResponsive = ({ hideModal }) => (
	<>
		<TabletOrDesktop>
			<ApprovedExpenses />
		</TabletOrDesktop>
		<Mobile>
			<>
				<Layout
					className="page-expenses page-expenses-approved mobile"
					context="expenses"
				>
					<MobileExpensesView />
				</Layout>
				<Modal hideModal={hideModal} />
			</>
		</Mobile>
	</>
);

export default connect(null, { hideModal })(ApprovedExpensesResponsive);
